class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.bindEvents();

    document.addEventListener(
      'keydown',
      this.handleEscapeKeyPress.bind(this)
    );
  }

  bindEvents() {
    const drawerBtn = document.querySelector('[data-cart-drawer]');

    if (drawerBtn) {
      drawerBtn.addEventListener(
        'click',
        this.openCartDrawer.bind(this)
      );
    }

    this.querySelectorAll('[data-close-drawer]').forEach((button) => {
      button.addEventListener(
        'click',
        this.closeDrawer.bind(this)
      );
    });

    this.setupDialogEvents();
  }

  setupDialogEvents() {
    let lastFocusedElement = '';

    Array.from(
      this.querySelectorAll('.modal-dialog-button')
    ).forEach((openBtn) => {
      openBtn.addEventListener('click', () => {
        const modalId = openBtn.dataset.modal;

        const dialog = this.querySelector(
          `cart-dialog#${modalId}`
        );

        if (dialog) {
          setTimeout(() => {
            dialog.classList.add('is-visible');

            setTimeout(() => {
              lastFocusedElement = openBtn;

              if (
                typeof trapFocusElements === 'function'
              ) {
                trapFocusElements(dialog);
              }
            }, 600);
          }, 500);
        }
      });
    });

    Array.from(
      this.querySelectorAll('[data-dialog-close]')
    ).forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const dialog =
          closeBtn.closest('cart-dialog');

        if (!dialog) return;

        dialog.classList.remove('is-visible');

        if (
          typeof trapFocusElements === 'function'
        ) {
          trapFocusElements(
            document.querySelector('cart-drawer')
          );
        }

        setTimeout(() => {
          if (lastFocusedElement) {
            lastFocusedElement.focus();
          }

          lastFocusedElement = '';
        }, 400);
      });
    });
  }

  openCartDrawer(event) {
    event.preventDefault();

    fetch(this.dataset.url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Cart drawer request failed: ${response.status}`
          );
        }

        return response.text();
      })
      .then((html) => {
        this.innerHTML =
          this.getSectionHTML(
            html,
            'cart-drawer'
          );

        this.classList.add('is-visible');

        const body =
          document.querySelector('body');

        if (body) {
          body.classList.add(
            'overflow-hidden'
          );
        }

        this.querySelectorAll(
          '[data-drawer-close]'
        ).forEach((button) => {
          button.addEventListener(
            'click',
            this.closeDrawer.bind(this)
          );
        });

        setTimeout(() => {
          window.focusElement =
            event.target;

          if (
            typeof trapFocusElements ===
            'function'
          ) {
            trapFocusElements(this);
          }
        }, 500);

        const cartBody =
          document.querySelector(
            '#cart-drawer-body-content'
          );

        if (cartBody) {
          const totalPrice =
            cartBody.getAttribute(
              'data-cart-price'
            );

          if (
            totalPrice &&
            typeof freeShippingBarProgress ===
              'function'
          ) {
            freeShippingBarProgress(
              totalPrice
            );
          }
        }

        this.setupDialogEvents();
      })
      .catch((error) => {
        console.error(
          'Cart drawer error:',
          error
        );
      });
  }

  renderContents(parsedState) {
    if (
      !parsedState ||
      !parsedState.sections
    ) {
      console.error(
        'Cart drawer: invalid cart response.',
        parsedState
      );
      return;
    }

    this.getSectionsToRender().forEach(
      (section) => {
        const sectionElement =
          document.getElementById(
            section.id
          );

        if (!sectionElement) {
          return;
        }

        const sectionHTML =
          this.getSectionHTML(
            parsedState.sections[
              section.id
            ],
            section.selector
          );

        if (!sectionHTML) {
          return;
        }

        const targetElement =
          this.querySelector(
            section.selector
          );

        if (!targetElement) {
          return;
        }

        targetElement.innerHTML =
          sectionHTML;

        const cartBody =
          this.querySelector(
            '#cart-drawer-body-content'
          );

        if (cartBody) {
          const totalPrice =
            cartBody.getAttribute(
              'data-cart-price'
            );

          if (
            totalPrice &&
            typeof freeShippingBarProgress ===
              'function'
          ) {
            freeShippingBarProgress(
              totalPrice
            );
          }

          const totalCount =
            cartBody.getAttribute(
              'data-cart-count'
            );

          const itemCountElement =
            document.querySelector(
              '[data-item-count]'
            );

          if (itemCountElement) {
            const count =
              Number(totalCount) || 0;

            itemCountElement.classList.remove(
              'hidden'
            );

            if (count === 0) {
              itemCountElement.classList.add(
                'hidden'
              );
            } else if (count < 100) {
              itemCountElement.textContent =
                count;
            } else {
              itemCountElement.textContent =
                '99+';
            }
          }
        }

        this.setupDialogEvents();

        this.querySelectorAll(
          '[data-drawer-close]'
        ).forEach((button) => {
          button.addEventListener(
            'click',
            this.closeDrawer.bind(this)
          );
        });

        if (
          typeof trapFocusElements ===
          'function'
        ) {
          trapFocusElements(this);
        }
      }
    );

    /*
     * IMPORTANT:
     * renderContents() must also OPEN the drawer
     * after Add to Cart.
     */

    this.classList.remove('is-empty');
    this.classList.add('is-visible');

    const body =
      document.querySelector('body');

    if (body) {
      body.classList.add(
        'overflow-hidden'
      );
    }

    this.setupDialogEvents();

    this.querySelectorAll(
      '[data-drawer-close]'
    ).forEach((button) => {
      button.addEventListener(
        'click',
        this.closeDrawer.bind(this)
      );
    });

    if (
      typeof trapFocusElements ===
      'function'
    ) {
      trapFocusElements(this);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section:
          document.getElementById(
            'cart-drawer'
          )?.dataset.id ||
          document.getElementById(
            'cart-drawer'
          )?.id,
        selector: 'cart-drawer'
      }
    ];
  }

  getSectionHTML(html, selector) {
    if (!html) {
      return '';
    }

    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      parsedHTML.querySelector(
        selector
      );

    if (!element) {
      return '';
    }

    return element.innerHTML;
  }

  closeDrawer(event) {
    if (event) {
      event.preventDefault();
    }

    this.classList.remove(
      'is-visible'
    );

    const body =
      document.querySelector('body');

    if (body) {
      body.classList.remove(
        'overflow-hidden'
      );
    }

    if (
      typeof trapFocusElements ===
      'function'
    ) {
      trapFocusElements(null);
    }
  }

  handleEscapeKeyPress(event) {
    if (
      event.key === 'Escape' &&
      this.classList.contains(
        'is-visible'
      )
    ) {
      this.closeDrawer(event);
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}